import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HomeIcon, BookOpenIcon, CalendarIcon, FolderIcon, ScrollTextIcon, AwardIcon, SettingsIcon, HelpCircleIcon, ChevronDownIcon, UsersIcon, UserIcon, CoffeeIcon, BarChartIcon } from 'lucide-react';
interface SidebarProps {
  activePage?: 'formazione' | 'community' | 'alga';
}
const Sidebar: React.FC<SidebarProps> = ({
  activePage = 'formazione'
}) => {
  const [corsoAttivo, setCorsoAttivo] = useState('Innovazione Sostenibile');
  const location = useLocation();
  const currentPath = location.pathname;
  const corsi = ['Innovazione Sostenibile', 'Economia Circolare', 'Energie Rinnovabili', "Responsabilità Sociale d'Impresa"];
  return <div className="w-full md:w-64 bg-black text-white h-full flex flex-col overflow-y-auto transition-all duration-300 relative" data-id="element-1318">
      <div className="p-4 flex justify-start" data-id="element-1319">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kYK3VqJh5ErppvW42Sa6wk/IMG_1178.png" alt="EIIS Logo" className="h-12 object-contain" data-id="element-1320" />
      </div>
      {/* Main navigation tabs */}
      <div className="px-4 py-3 border-b border-[#171717]" data-id="element-1321">
        <div className="flex items-center justify-between bg-[#212121] rounded-lg p-1 w-full" data-id="element-1322">
          <Link to="/" className={`py-2 px-3 rounded-md text-sm font-medium transition-colors flex-1 text-center ${activePage === 'formazione' ? 'bg-custom-green text-white' : 'text-white hover:text-white'}`} data-id="element-1323">
            Formazione
          </Link>
          <Link to="/community" className={`py-2 px-3 rounded-md text-sm font-medium transition-colors flex-1 text-center ${activePage === 'community' ? 'bg-custom-green text-white' : 'text-white hover:text-white'}`} data-id="element-1324">
            Community
          </Link>
        </div>
      </div>
      {/* Course selector - only for formazione */}
      {activePage === 'formazione' && <div className="px-4 py-3 border-b border-[#171717]" data-id="element-1325">
          <div className="relative w-full" data-id="element-1326">
            <select value={corsoAttivo} onChange={e => setCorsoAttivo(e.target.value)} className="w-full bg-[#212121] text-white px-3 py-2 rounded-lg appearance-none pr-10 cursor-pointer border border-[#171717] focus:outline-none focus:border-lime-500" data-id="element-1327">
              {corsi.map(corso => <option key={corso} value={corso} data-id="element-1328">
                  {corso}
                </option>)}
            </select>
            <ChevronDownIcon size={18} className="absolute right-3 top-2.5 text-gray-400 pointer-events-none" data-id="element-1329" />
          </div>
        </div>}
      {/* Main menu items */}
      <div className="px-4 py-6 flex-1 w-full" data-id="element-1330">
        {activePage === 'formazione' ? <div className="space-y-1 w-full" data-id="element-1331">
            <h3 className="text-xs uppercase tracking-wider text-gray-400 font-semibold mb-3 px-3" data-id="element-1332">
              Corso
            </h3>
            <Link to="/" className="block w-full" data-id="element-1333">
              <SidebarItem icon={<HomeIcon size={20} data-id="element-1335" />} text="Panoramica" active={currentPath === '/' || currentPath === ''} data-id="element-1334" />
            </Link>
            <Link to="/corso" className="block w-full" data-id="element-1336">
              <SidebarItem icon={<BookOpenIcon size={20} data-id="element-1338" />} text="Il Mio Corso" active={currentPath === '/corso'} data-id="element-1337" />
            </Link>
            <SidebarItem icon={<CalendarIcon size={20} data-id="element-1340" />} text="Calendario" data-id="element-1339" />
            <SidebarItem icon={<FolderIcon size={20} data-id="element-1342" />} text="Materiali" data-id="element-1341" />
            <SidebarItem icon={<ScrollTextIcon size={20} data-id="element-1344" />} text="Note" data-id="element-1343" />
            <SidebarItem icon={<AwardIcon size={20} data-id="element-1346" />} text="Certificazioni" data-id="element-1345" />
          </div> : activePage === 'community' ? <div className="space-y-1 w-full" data-id="element-1347">
            <h3 className="text-xs uppercase tracking-wider text-gray-400 font-semibold mb-3 px-3" data-id="element-1348">
              Community
            </h3>
            <Link to="/community" className="block w-full" data-id="element-1349">
              <SidebarItem icon={<HomeIcon size={20} data-id="element-1351" />} text="Panoramica" active={location.pathname === '/community'} data-id="element-1350" />
            </Link>
            <Link to="/connections" className="block w-full" data-id="element-1352">
              <SidebarItem icon={<UsersIcon size={20} data-id="element-1354" />} text="Connessioni" active={location.pathname === '/connections'} data-id="element-1353" />
            </Link>
            <Link to="/groups" className="block w-full" data-id="element-1355">
              <SidebarItem icon={<UserIcon size={20} data-id="element-1357" />} text="Gruppi" active={location.pathname === '/groups'} data-id="element-1356" />
            </Link>
            <Link to="/coffee" className="block w-full" data-id="element-1358">
              <SidebarItem icon={<CoffeeIcon size={20} data-id="element-1360" />} text="EIIS Coffee" active={location.pathname === '/coffee'} data-id="element-1359" />
            </Link>
            <SidebarItem icon={<BarChartIcon size={20} data-id="element-1362" />} text="Report & Statistiche" data-id="element-1361" />
          </div> : <div className="space-y-1 w-full" data-id="element-1363">
            <h3 className="text-xs uppercase tracking-wider text-gray-400 font-semibold mb-3 px-3" data-id="element-1364">
              Assistente AI
            </h3>
            <SidebarItem icon={<HomeIcon size={20} data-id="element-1366" />} text="Chat con ALGA" active data-id="element-1365" />
          </div>}
        {/* Settings section */}
        <div className="mt-10 pt-6 border-t border-[#171717] space-y-1 w-full" data-id="element-1367">
          <h3 className="text-xs uppercase tracking-wider text-gray-400 font-semibold mb-3 px-3" data-id="element-1368">
            Impostazioni
          </h3>
          <SidebarItem icon={<SettingsIcon size={20} data-id="element-1370" />} text="Impostazioni" data-id="element-1369" />
          <SidebarItem icon={<HelpCircleIcon size={20} data-id="element-1372" />} text="Assistenza" data-id="element-1371" />
        </div>
      </div>
    </div>;
};
interface SidebarItemProps {
  icon: React.ReactNode;
  text: string;
  active?: boolean;
}
const SidebarItem: React.FC<SidebarItemProps> = ({
  icon,
  text,
  active = false
}) => {
  return <div className={`flex items-center px-3 py-2 cursor-pointer transition-colors w-full border-l-4 ${active ? 'bg-[#222222] text-white border-custom-green' : 'text-gray-300 hover:bg-[#2e2e2e] hover:text-white border-transparent'}`} data-id="element-1373">
      <span className="mr-3 text-gray-400" data-id="element-1374">{icon}</span>
      <span className="font-medium text-sm" data-id="element-1375">{text}</span>
    </div>;
};
export default Sidebar;